const lightTheme = {
  body: '#E5E5E5',
  color: '#000',
  headerBg: '#5e72e4',
  textTiny: 'rgb(70, 70, 70)',
  btn: {
    primary: '#5e72e4',
    info: '#11cdef',
    success: '#2dce89',
    warning: '#fb6340;',
    darger: '#f5365c',
  },
  card: {
    background: '#fff',
    hover: 'rgb(240, 240, 240)',
    headerBg: '##5e72e4',
    headerHoverText: '#000',
    btnShadow: '0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);',
  },
};

const darkTheme = {
  body: '#1e1e2f',
  color: '#fff',
  headerBg: '#7b1fa2',
  textTiny: '#fff',
  btn: {
    primary: '#7b1fa2',
    info: '#3358f4',
    success: '#00f2c3',
    warning: '#ff8d72',
    darger: '#fd5d93',
  },
  card: {
    background: '#27293d',
    hover: 'hsla(0,0%,100%,.1)',
    headerBg: '#7b1fa2',
    headerHoverText: '#fff',
    btnShadow: '2px 2px 6px rgba(0, 0, 0, 0.4)',
  },
};

export { lightTheme, darkTheme };
